import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { useState } from 'react';
import { ListingActionMenu } from '../ListingActionMenu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EcosystemListingCard({
  name,
  providerName,
  description,
  listingHref,
  imageSrcBig,
  imageSrcSmall,
  metaBadges = [],
  actions = [],
  onActionClick = () => {}
}) {
  const [isHovered, setIsHovered] = useState(false);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    compact: true,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: [/*#__PURE__*/_jsx(Link, {
      href: listingHref,
      children: /*#__PURE__*/_jsxs(View, {
        backgroundColor: "fill-surface-raised",
        blockSize: "164px",
        borderStartEndRadius: "100",
        borderStartStartRadius: "100",
        overflow: "hidden",
        position: "relative",
        children: [imageSrcBig && /*#__PURE__*/_jsx(Image, {
          blockSize: "164px",
          inlineSize: "100%",
          objectFit: "cover",
          src: imageSrcBig
        }), imageSrcSmall && /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          inset: "0",
          justifyContent: "center",
          position: "absolute",
          children: /*#__PURE__*/_jsx(Image, {
            src: imageSrcSmall,
            blockSize: "100px"
          })
        })]
      })
    }), actions.length > 0 && isHovered && /*#__PURE__*/_jsx(View, {
      position: "absolute",
      insetInlineEnd: "16px",
      insetBlockStart: "16px",
      children: /*#__PURE__*/_jsx(ListingActionMenu, {
        actions: actions,
        onActionClick: onActionClick
      })
    }), /*#__PURE__*/_jsxs(CardSection, {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(Link, {
          href: listingHref,
          use: "unstyled",
          children: name
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "trellisEcosystem.appCard.providerName",
          options: {
            providerName
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        marginBlock: "300",
        children: description
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "end",
        gap: "200",
        marginBlockStart: "auto",
        children: metaBadges.map(metaBadge => /*#__PURE__*/_jsx(Link, {
          href: metaBadge.href,
          children: /*#__PURE__*/_jsx(Badge, {
            use: "koala",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "100",
              children: [metaBadge.label, metaBadge.icon]
            })
          })
        }, metaBadge.label))
      })]
    })]
  });
}